import React from 'react';
import SideBarMobile from '../../../shared/templates/CategoryTemplate/category-sidebar-mobile';

function PhotosSideBarMobile(props) {
  return (<SideBarMobile {...props}
    section="photos"
    searchTitle="Search Photos"
    createNewTitle="New Gallery"
    filterList={[
      { name: 'keywords', value: 'Enter Keywords' },
    ]}
  />);
}

export default PhotosSideBarMobile;